module.exports = __webpack_public_path__ + "img/free_multiplier_2.e6b11adc.png";